import { Action } from 'redux';
import { BreadcrumbStateInfo } from '../content/breadcrumbs/BreadcrumbStateInfo';
import { UpdateBreadcrumbs } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';

export interface UpdateBreadcrumbsAction extends  Action {
  breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>;
}

export function updateBreadcrumbs(breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>): UpdateBreadcrumbsAction {
  return {
    type: UpdateBreadcrumbs,
    breadcrumbs
  };
}

export const isUpdateBreadcrumbsAction = isActionFactory<UpdateBreadcrumbsAction>(UpdateBreadcrumbs);
